import {SvgIcon} from "@material-ui/core";

export const CustomBookListIcon = (props) => {
    return (
        <SvgIcon width="20" height="21" viewBox="0 0 20 21" fill="#CDBDDB" {...props}>
            <path d="M2.5 16.3744H17.5V11.3744H2.5V16.3744ZM2.5 9.70776H17.5V8.0411H2.5V9.70776ZM2.5 4.70776V6.37443H17.5V4.70776H2.5Z"/>
        </SvgIcon>
    )
}